<!-- <div class="border mb-4" *ngIf="type=='AgeWiseEarning'" >
 <h6 class="chart-title">Age wise Estimated Annual Earnings</h6>
    <div class="mGraph-wrapper">
        <div class="mGraph" id="lineChart"></div>
    </div>
</div> -->

<div class="border mb-8">
    <h6 class="chart-title">{{title}}</h6>
       <div class="mGraph-wrapper">
           <div class="mGraph" id="lineChart"></div>
       </div>
   </div>